/**
 * API Service - Substituição do Supabase
 * Chamadas HTTP para o backend PHP
 */

const API_BASE_URL = '/upmidia/api';

class APIService {
  constructor() {
    this.token = localStorage.getItem('auth_token') || null;
  }

  /**
   * Fazer requisição HTTP
   */
  async request(endpoint, method = 'GET', data = null) {
    const url = `${API_BASE_URL}${endpoint}`;
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
      }
    };

    if (this.token) {
      options.headers['Authorization'] = `Bearer ${this.token}`;
    }

    if (data) {
      options.body = JSON.stringify(data);
    }

    try {
      const response = await fetch(url, options);
      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || 'Erro na requisição');
      }

      return json.data || json;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  /**
   * Autenticação
   */
  async login(email, password) {
    const response = await this.request('/auth/login.php', 'POST', {
      email,
      password
    });

    this.token = response.token;
    localStorage.setItem('auth_token', response.token);

    return response;
  }

  async logout() {
    this.token = null;
    localStorage.removeItem('auth_token');
  }

  /**
   * Conteúdo
   */
  async getContent(filters = {}) {
    const params = new URLSearchParams();

    if (filters.category) params.append('category', filters.category);
    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);

    return this.request(`/content/get.php?${params.toString()}`);
  }

  async createContent(data) {
    return this.request('/content/create.php', 'POST', data);
  }

  async updateContent(id, data) {
    return this.request('/content/update.php', 'PUT', { id, ...data });
  }

  async deleteContent(id) {
    return this.request('/content/delete.php', 'DELETE', { id });
  }

  /**
   * Categorias
   */
  async getCategories() {
    return this.request('/category/get.php');
  }

  /**
   * Upload de arquivo
   */
  async uploadFile(file, folder = '') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    formData.append('fileName', `${Date.now()}-${Math.random().toString(36).substring(7)}.${file.name.split('.').pop()}`);

    const options = {
      method: 'POST',
      body: formData
    };

    if (this.token) {
      const headers = new Headers();
      headers.append('Authorization', `Bearer ${this.token}`);
      options.headers = headers;
    }

    try {
      const response = await fetch(`/upmidia/uploads/api/upload.php`, options);
      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.message || 'Erro ao fazer upload');
      }

      return json;
    } catch (error) {
      console.error('Upload Error:', error);
      throw error;
    }
  }
}

export const apiService = new APIService();
